export default function isCrossPrice(item, { minimumPercentageValue, minimumAbsoluteValue })
{
    if (!item)
    {
        return false;
    }
    return item.prices.rrp &&
                item.prices.rrp.price.value > 0 &&
                (item.prices.rrp.price.value - minimumAbsoluteValue >= item.prices.default.price.value &&
                   1 - item.prices.default.price.value / item.prices.rrp.price.value >= minimumPercentageValue / 100);
}
